import React from 'react'
import styled from '@emotion/styled'
import { H2, P1 } from 'src/components/Typography'
import Divider from 'src/components/Divider'
import CrossIcon from 'src/icons/Cross'
import { useTheme } from 'src/shared/themeContext'
import { EXTRA_LARGE_SPACING, LARGE_SPACING, SMALL_SPACING } from 'src/constants/spacing'

type ModalContentProps = {
  onClose: () => void
  icon: React.ReactNode | false
  title: React.ReactNode
  children: React.ReactNode
  footer: React.ReactNode
  disabledCloseIcon?: boolean
}

const ModalContent = ({
  onClose,
  icon,
  title,
  children,
  footer,
  disabledCloseIcon,
}: ModalContentProps) => {
  const { neutral } = useTheme()
  return (
    <>
      <ModalHeader hasIcon={Boolean(icon)}>
        <TitleContainer>
          <Title>
            {icon}
            <H2>{title}</H2>
          </Title>
          {!disabledCloseIcon && (
            <Close onClick={() => onClose()}>
              <CrossIcon color={neutral.text} width={18} />
            </Close>
          )}
        </TitleContainer>
        <Divider />
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>{footer}</ModalFooter>
    </>
  )
}
export default ModalContent

const ModalHeader = styled.div<{ hasIcon: boolean }>`
  ${props =>
    props.hasIcon
      ? `
      height: 86px;
    `
      : `
      height: 73px;
    `}
  padding-left: ${EXTRA_LARGE_SPACING};
  padding-right: ${EXTRA_LARGE_SPACING};
`

const ModalBody = styled(P1)`
  border-bottom: 1px solid #e8e8e8;
  padding-top: ${LARGE_SPACING};
  padding-left: ${EXTRA_LARGE_SPACING};
  padding-right: ${EXTRA_LARGE_SPACING};
  padding-bottom: ${EXTRA_LARGE_SPACING};
`

const ModalFooter = styled.div`
padding-top: 
  background: #f6f7f9;
  display: flex;
  justify-content: flex-end;
  padding-right: ${EXTRA_LARGE_SPACING};
  padding-top: ${SMALL_SPACING};
  padding-bottom: ${SMALL_SPACING};
`

const TitleContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Title = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
  & :not(:last-child) {
    margin-right: 10px;
  }
`

const Close = styled.div`
  cursor: pointer;
  padding-left: 5px;
  padding-right: 5px;
  margin-right: -5px;
`
